import { render } from "./Points.vue?vue&type=template&id=dd566472&ts=true"
import script from "./Points.vue?vue&type=script&lang=ts"
export * from "./Points.vue?vue&type=script&lang=ts"

import "./Points.vue?vue&type=style&index=0&id=dd566472&lang=scss"

import exportComponent from "/home/gitlab-runner/builds/5c6defa0/0/anyclass/anyclass-frontend/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__